const linkClass =
  "h-9 px-4 rounded-full border border-[#E4DDD3] bg-white/70 backdrop-blur text-sm font-medium text-slate-600 hover:text-terra-600 hover:border-terra-400/50 transition-colors flex items-center";

export default function PublicNav() {
  return (
    <nav className="flex items-center gap-2" data-testid="public-nav">
      <a href="mailto:svekovius@gmail.com" className={linkClass} data-testid="nav-contact-link">
        Contact Us
      </a>
    </nav>
  );
}
